import { createContext, useState } from "react";

export const SelectedDashBoardBuilderElements = createContext()

export const SelectedDashBoardBuilderElementsProvider = (props) => {
    const [selectedLayoutId, setSelectedLayoutId] = useState(null)
    const [selectedLayoutDocId, setSelectedLayoutDocId] = useState(null)
    const [selectedElementId, setSelectedElementId] = useState(null)
    const [selectedElementDocId, setSelectedElementDocId] = useState(null)
    const [selectedItemId, setSelectedItemId] = useState(null)
    const [selectedItemDocId, setSelectedItemDocId] = useState(null)

    return(
        <SelectedDashBoardBuilderElements.Provider value={{
            selectedLayoutId, setSelectedLayoutId, 
            selectedLayoutDocId, setSelectedLayoutDocId, 
            selectedElementId, setSelectedElementId,
            selectedElementDocId, setSelectedElementDocId, 
            selectedItemId, setSelectedItemId, 
            selectedItemDocId, setSelectedItemDocId}}
            >
            {props.children}
        </SelectedDashBoardBuilderElements.Provider>
    )
}